import { render, staticRenderFns } from "./TeacherFileList.vue?vue&type=template&id=13f8c5d0&scoped=true&"
import script from "./TeacherFileList.vue?vue&type=script&lang=js&"
export * from "./TeacherFileList.vue?vue&type=script&lang=js&"
import style0 from "./TeacherFileList.vue?vue&type=style&index=0&id=13f8c5d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f8c5d0",
  null
  
)

export default component.exports